import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { BoardTypeEnum } from 'modules/core/domain/interfaces/supabase/overlay/auxiliary-types';
import { selectActiveBoard } from '../../store/templates/selectors';
import useLocalStorage from '../../ui/hooks/use-local-storage';

/**
 * Хук для получения текущего типа доски (boardType)
 * @returns текущий тип доски с учетом активной доски или из localStorage
 */
export const useGetBoardType = (): BoardTypeEnum | undefined => {
  const activeBoard = useSelector(selectActiveBoard);
  const { getData } = useLocalStorage();

  return useMemo(() => {
    const localStorageBoardType = getData().boardType as BoardTypeEnum;
    return activeBoard?.type ?? localStorageBoardType;
  }, [activeBoard?.type, getData]);
};
